import { isDateString } from './isDateString'

const reviveDates = (_key: string, value: unknown): unknown =>
  isDateString(value) ? new Date(value) : value

export async function parseJSON<T>(response: Response): Promise<T> {
  if (response.status === 204 || response.status === 205) {
    return null as unknown as T
  }
  const respAsText = await response.text()
  if (respAsText) {
    return JSON.parse(respAsText, reviveDates)
  }
  return null as unknown as T
}
